import { render, staticRenderFns } from "./SettingAdminModal.vue?vue&type=template&id=acc2a05e&scoped=true&"
import script from "./SettingAdminModal.vue?vue&type=script&lang=js&"
export * from "./SettingAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingAdminModal.vue?vue&type=style&index=0&id=acc2a05e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc2a05e",
  null
  
)

export default component.exports